import * as React from 'react';

import { getText } from '../../../helpers';
import buildUrl from '../../../utilities/build-url';
import Tile from '..';
import buildImageUrl from '../../../utilities/build-image-url';

export default function SolutionTile(props: SolutionTileProps) {
    const { className, solution, newTab, key } = props;
    const {
        MarketSolutionProvider,
        MktplaceSolutionName,
        AbsoluteSolutionName,
        MktplaceSolutionDesc,
        PlatformService,
        MktplaceDateAdded,
        MktplaceSolutionCurrentVerDate,
        KeyPlatformService,
        MktplaceSolutionUrlName
    } = solution;
    const { MktplaceSolutionProvider } = MarketSolutionProvider;
    const solutionPathSegment = buildUrl(AbsoluteSolutionName || MktplaceSolutionUrlName || MktplaceSolutionName, KeyPlatformService);
    const langCode = getText('langCode');
    let url = `/${langCode}/solutions/${solutionPathSegment}`;
    if (newTab) url = window.location.origin.concat(url);
    const thumbnailImageFilePath = (PlatformService && PlatformService.ThumbnailImageFilePath) || undefined;


    const pathOverride = buildImageUrl(thumbnailImageFilePath);

    return (
        <Tile
            className={className}
            provider={MktplaceSolutionProvider}
            name={MktplaceSolutionName}
            description={MktplaceSolutionDesc}
            imgUrl={pathOverride}
            addedDate={MktplaceDateAdded}
            enhancementDate={MktplaceSolutionCurrentVerDate}
            url={url}
            buttonText={getText('generic.viewSolution')}
            tileType="Solutions"
            id={KeyPlatformService}
        />
    );
}
